var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import { useEffect, useState } from 'react';
import Typography from '../Typography';
import { useRef } from 'react';
import { Box } from '@mui/material';
export var ExpandableTypographyTestId = 'Sweep_Expandable_Typography';
export var ExpandableTypographyButtonTestId = 'Sweep_Expandable_Typography_Button';
export var defaultShowLessLabel = 'Show less';
export var defaultShowMoreLabel = 'Show more';
var addMultipleLineEllipsis = function (lines) { return ({
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'break-spaces',
}); };
var ANIMATION_DURATION = 300; // in milliseconds
var ExpandableTypography = function (props) {
    var children = props.children, _a = props.rows, rows = _a === void 0 ? 2 : _a, _b = props.showMoreLabel, showMoreLabel = _b === void 0 ? defaultShowMoreLabel : _b, _c = props.showLessLabel, showLessLabel = _c === void 0 ? defaultShowLessLabel : _c, onShowMoreCallback = props.onShowMoreCallback, restProps = __rest(props, ["children", "rows", "showMoreLabel", "showLessLabel", "onShowMoreCallback"]);
    var _d = useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = useState(false), isAnimating = _e[0], setIsAnimating = _e[1];
    var _f = useState('auto'), lineHeight = _f[0], setLineHeight = _f[1];
    var _g = useState('auto'), height = _g[0], setHeight = _g[1];
    var _h = useState(false), needShowMore = _h[0], setNeedShowMore = _h[1];
    var myRef = useRef(null);
    useEffect(function () {
        var _a, _b;
        if ((myRef === null || myRef === void 0 ? void 0 : myRef.current) && rows) {
            var refStyles = window.getComputedStyle(myRef.current);
            var currentLineHeight = Number((_a = refStyles.lineHeight) === null || _a === void 0 ? void 0 : _a.replace('px', ''));
            var currentHeight = Number((_b = refStyles.height) === null || _b === void 0 ? void 0 : _b.replace('px', ''));
            setLineHeight(currentLineHeight * rows + 'px');
            setHeight(currentHeight + 'px');
            if (!isExpanded && !needShowMore) {
                setNeedShowMore((myRef === null || myRef === void 0 ? void 0 : myRef.current.offsetHeight) < (myRef === null || myRef === void 0 ? void 0 : myRef.current.scrollHeight));
            }
        }
    }, [myRef, isExpanded, rows, height, lineHeight, needShowMore]);
    //If length of the next changes calculate again
    useEffect(function () {
        if (myRef === null || myRef === void 0 ? void 0 : myRef.current) {
            setNeedShowMore((myRef === null || myRef === void 0 ? void 0 : myRef.current.offsetHeight) < (myRef === null || myRef === void 0 ? void 0 : myRef.current.scrollHeight));
        }
    }, [children]);
    //need to add the ellipsis css only when done animating the collapse
    useEffect(function () {
        if (isAnimating) {
            setTimeout(function () {
                setIsAnimating(false);
            }, ANIMATION_DURATION);
        }
    }, [isAnimating, setIsAnimating]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ "data-testid": ExpandableTypographyTestId, sx: {
                    maxHeight: isExpanded ? height : lineHeight,
                    overflow: 'hidden',
                    transition: "".concat(ANIMATION_DURATION / 1000, "s ease-in-out"),
                    marginBottom: '5px',
                    '& .MuiTypography-root': __assign({ display: '-webkit-box' }, (!isAnimating && !isExpanded ? addMultipleLineEllipsis(rows) : {})),
                } }, { children: _jsx(Typography, __assign({ ref: myRef }, restProps, { children: children })) })), needShowMore && (_jsx(Button, __assign({ dataTestId: ExpandableTypographyButtonTestId, variant: "flat", type: "secondary", onClick: function () {
                    if (onShowMoreCallback && !isExpanded) {
                        onShowMoreCallback();
                    }
                    setIsAnimating(true);
                    setIsExpanded(!isExpanded);
                }, endIconName: isExpanded ? 'ChevronUp' : 'ChevronDown' }, { children: isExpanded ? showLessLabel : showMoreLabel })))] }));
};
export default ExpandableTypography;
